import React from 'react';
import { Info } from 'lucide-react';
export function KidsTaekwondoBridge() {
  return <section className="py-12 bg-storm-red text-white" data-id="element-2183">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2184">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-2185">
          <Info className="w-8 h-8" data-id="element-2186" />
          <h2 className="text-3xl m-0" data-id="element-2187">Looking for Karate?</h2>
        </div>
        <p className="text-xl leading-relaxed" data-id="element-2188">
          Many parents search for "karate" when they mean martial arts. Storm
          teaches Olympic-style Taekwondo, a dynamic martial art that develops
          discipline, confidence, and self-defense skills.
        </p>
      </div>
    </section>;
}